import * as React from "react";
import { cn } from "@/lib/utils";

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
    /** When explicitly set to `false` the element is not rendered. */
    visible?: boolean;
}

const TableCell = React.forwardRef<HTMLTableCellElement, TableCellProps>(
    ({ visible, className, ...props }, ref) => {
        if (visible === false) return null;
        return (
            <td
                ref={ref}
                className={cn(
                    "p-2.5 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
                    className,
                )}
                {...props}
            />
        );
    },
);
TableCell.displayName = "TableCell";

export { TableCell };
export type { TableCellProps };
